// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__22tAX","content":"ManualTimeModal_content__3wYaU"};